import * as React from "react";

import { cn } from "@/lib/utils";

import type { PolicyViewSummaryDocument } from "../ExecutionRulesSimulator/policyTreeUtils";

const POLICY_SUMMARY_CONDITION_CLASS =
  "font-[family-name:var(--font-primary)] font-normal text-[color:var(--brand-tropical-surf)]";

export function PolicyViewSummaryContent({
  document,
  className,
  paragraphClassName,
}: {
  document: PolicyViewSummaryDocument;
  className?: string;
  paragraphClassName?: string;
}): React.ReactElement {
  return (
    <div className={cn("flex flex-col gap-4", className)}>
      {document.map((paragraph, paragraphIndex) => (
        <p
          key={`policy-summary-paragraph-${paragraphIndex}`}
          className={cn("m-0 font-[family-name:var(--font-primary)] text-sm font-normal leading-6 text-gray-500 dark:text-white", paragraphClassName)}
        >
          {paragraph.map((part, partIndex) =>
            part.kind === "condition" ? (
              <span
                key={`policy-summary-part-${paragraphIndex}-${partIndex}`}
                className={POLICY_SUMMARY_CONDITION_CLASS}
              >
                {part.text}
              </span>
            ) : (
              <span key={`policy-summary-part-${paragraphIndex}-${partIndex}`}>{part.text}</span>
            )
          )}
        </p>
      ))}
    </div>
  );
}
